import { COVERGO_ASIA_PROD, COVERGO_SAAS_DEV } from "../consts.js"

export const asisken = {
	"asisken-studio.uat.asia.covergo.cloud": {
		appConfig: {
			tenantId: "asisken_uat",
			appId: "admin_portal"
		},
		envConfig: COVERGO_ASIA_PROD
	},
	"asisken-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "asisken_dev",
			appId: "admin_portal"
		},
		envConfig: COVERGO_SAAS_DEV
	}
}
